import { useState, useCallback } from 'react';

export default function useDataTableControls() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [filters, setFilters] = useState({});

  const changePage = useCallback((newPage) => {
    setPage(newPage);
  }, []);

  const changeRowsPage = useCallback((newRowsPerPage) => {
    changePage(0);
    setRowsPerPage(newRowsPerPage);
  }, []);

  const changeFilters = useCallback((newFilters) => {
    changePage(0);
    setFilters(newFilters);
  }, []);

  const resetFilters = useCallback((newFilters) => {
    changePage(0);
    setFilters({});
  }, []);

  return {
    page,
    rowsPerPage,
    filters,
    changePage,
    changeRowsPage,
    changeFilters,
    resetFilters
  }
}